export default {"src":"/_next/static/media/icon-residentialLand.61410bf6.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};